import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { adminCinemas, adminDeleteCinema } from '../../api/endpoints';
import TopBar from '../../components/TopBar';
import Splash from '../../components/Splash';
import { showAlert, showConfirm } from '../../lib/tg';

export default function CinemasList() {
  const navigate = useNavigate();
  const qc = useQueryClient();
  const { data, isLoading } = useQuery({ queryKey: ['admin-cinemas'], queryFn: adminCinemas });

  const delMut = useMutation({
    mutationFn: (id: number) => adminDeleteCinema(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['admin-cinemas'] }),
    onError: (e: any) => {
      const detail = e?.response?.data?.detail;
      showAlert(typeof detail === 'string' ? detail : 'Не удалось удалить');
    },
  });

  async function onDelete(id: number, name: string) {
    if (await showConfirm(`Удалить кинотеатр «${name}»?`)) delMut.mutate(id);
  }

  if (isLoading) return <Splash />;

  return (
    <div className="min-h-screen pb-32">
      <TopBar title="Кинотеатры" />
      <div className="px-4 pt-3 space-y-2">
        {data?.map((c) => (
          <div key={c.id} className="card p-4">
            <button
              className="block w-full text-left"
              onClick={() => navigate(`/admin/cinemas/${c.id}/edit`)}
            >
              <div className="font-semibold">{c.name}</div>
              {c.address && <div className="text-xs text-muted mt-0.5">{c.address}</div>}
            </button>
            <div className="grid grid-cols-3 gap-2 mt-3">
              <button
                className="btn-secondary text-sm"
                onClick={() => navigate(`/admin/cinemas/${c.id}/edit`)}
              >
                Изменить
              </button>
              <button
                className="btn-secondary text-sm"
                onClick={() => navigate(`/admin/cinemas/${c.id}/seats`)}
              >
                Схема
              </button>
              <button
                className="btn-secondary text-sm !text-danger"
                onClick={() => onDelete(c.id, c.name)}
              >
                Удалить
              </button>
            </div>
          </div>
        ))}
        {!data?.length && <div className="text-muted text-center py-8">Пусто</div>}
      </div>
      <div className="fixed bottom-0 inset-x-0 p-4 bg-bg border-t border-line">
        <button className="btn-primary" onClick={() => navigate('/admin/cinemas/new')}>
          + Добавить кинотеатр
        </button>
      </div>
    </div>
  );
}
